module.exports = __webpack_public_path__ + "img/term-alert-icon.cb0744f5.svg";